import { AccessibilityClickableDiv } from '@skillz/accessibility';
import ScrollLTR from '../../../../../../../shared/components/ui/scrollLTR/ScrollLTR';
import StudyGroupSelectCard from './studyGroupSelectCard/StudyGroupSelectCard';
import classes from '../UserStudyGroups.module.css';

const StudyGroupListSection = ({ title, groups, selectable, selectedId, onSelect, showDomainInfo }) => {

  return (
    groups?.length > 0 && (
      <div className={showDomainInfo ? classes.DomainSection : classes.Section}>
        {title && (
          <p className={showDomainInfo ? classes.DomainTitle : classes.Title}>
            {title}
          </p>
        )}
        <ScrollLTR downDropStyle={showDomainInfo ? classes.DomainGroups : classes.GroupList} dropClass={showDomainInfo ? classes.DomainScroll : classes.DropScroll}>
          {groups.map(group => {
            const isActive = selectable && group?.id === selectedId;
            return showDomainInfo ? (
              <StudyGroupSelectCard key={group?.id} group={group} isActive={isActive} selectable={selectable} onSelect={onSelect} showDomainInfo={showDomainInfo} />
            ) : (
              <AccessibilityClickableDiv
                key={group?.id}
                className={[classes.Group, isActive ? classes.Active : "", !selectable ? classes.Disable : ""].join(" ")}
                onClick={selectable ? () => onSelect(group) : undefined}
              >
                {!selectable && group?.disable &&
                  <div className={classes.Tooltip}>{group?.message}</div>
                }
                <p className={classes.Field}>{group?.name}</p>
              </AccessibilityClickableDiv>
            );
          })}
        </ScrollLTR>
      </div>
    )
  );
};
export default StudyGroupListSection